export default __webpack_public_path__ + "static/media/042-mall.cd25075d.svg";